import { stripeProcessing } from '../stripeProcessing';
import { mobilePayment } from './reducer';
import { PaymentMobileService } from './service';

export const { actions, reducer } = mobilePayment;
export * as selectors from './selectors';

export const paymentMobileService = new PaymentMobileService(stripeProcessing);

// TODO: удалить и заменить на domains/processing
